export const DocumentationType = {
    Sts: "sts",
    Lts: "lts",
    LtsBeta: "ltsbeta"
}